
import Vue from 'vue';
import App from './views/AppRoute.vue';


//vuex setup
import store from './store'


import '../css/reset.styl'

// model viewer
import renderer from './modelviewer/renderer'
(async ()=>{
  await renderer.init();
})();

// inject model viewer as global variable
Vue.prototype.$viewer = renderer;

// // setup global mixin
// const wp_data = {
//   data: () => {
//     return {
//       base_url: _WP.base_url
//     }
//   }
// }
// Vue.mixin(wp_data)



new Vue({
  render: createElement => createElement(App),
  store: store}
  ).$mount('#app');
